<template>
  <div>
    <template v-if="!isZCUser">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>C端数据管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <!-- 筛选 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="120px"
        ref="queryFormRef"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="赛区" prop="districtId">
              <el-select
                placeholder="请选择"
                style="width: 100%"
                v-model="queryForm.districtId"
                clearable
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="queryForm.userName"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              label-width="120px"
              label="学校省市区"
              prop="schoolArea"
            >
              <el-cascader
                placeholder="请选择"
                clearable
                v-model="schoolArea"
                ref="schoolAreaRef"
                :options="areasData"
                style="width: 100%"
                :props="{
                  expandTrigger: 'hover',
                  label: 'name',
                  value: 'areaId',
                  children: 'areas',
                }"
                @change="provincesHandleChangeSearch"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学校" prop="schoolId">
              <el-select
                ref="schoolSelectRef"
                style="width: 100%"
                placeholder="请选择"
                v-model="queryForm.schoolId"
                clearable
                filterable
              >
                <el-option
                  v-for="item in provincesSchoolListSearch"
                  :key="item.id"
                  :label="item.schoolName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item> </el-col
        ></el-row>
      </el-form>
      <el-row :gutter="20" type="flex" justify="end">
        <el-col :span="2">
          <el-button
            type="primary"
            style="width: 100%"
            @click="getDataList('search')"
            >查询</el-button
          >
        </el-col>
        <el-col :span="2">
          <el-button type="primary" plain style="width: 100%" @click="reset"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- 注册信息列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col :span="12">
          <span class="title_class">信息列表</span>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-button type="primary" @click="addUserClicked()"
            >新增用户+</el-button
          >
          <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="exportTable()"
            >批量导出</el-button
          >
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="账号">
              <template slot-scope="scope">
                <MaskedPhone :phone="scope.row.phone" />
              </template>
            </el-table-column>
        <el-table-column label="姓名" prop="userName">
          <template slot-scope="scope">
            {{ scope.row.userName || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          label="性别"
          prop="sex"
          :formatter="genderFormatter"
        ></el-table-column>
        <el-table-column
          label="组别"
          prop="level"
          :formatter="groupFormatter"
        ></el-table-column>
        <el-table-column label="学校" prop="schoolName">
          <template slot-scope="scope">
            {{ scope.row.schoolName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="年级" prop="grade">
          <template slot-scope="scope">
            {{ scope.row.grade || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          label="证件类型"
          prop="cardType"
          :formatter="cardTypeFormatter"
        ></el-table-column>
        <el-table-column label="证件号码" prop="idCard">
          <template slot-scope="scope">
            {{ scope.row.idCard || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="所处赛段" prop="scheduleName" v-if="!showOperationColumn">
          <template slot-scope="scope">
            {{ scope.row.lastRaceSchedule && scope.row.lastRaceSchedule.scheduleName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="订单状态" prop="status" v-if="!showOperationColumn">
          <template slot-scope="scope">
            <template v-if="scope.row.lastRaceSchedule && scope.row.lastRaceSchedule.scheduleFlag">
              <el-tag v-if="['NATIONAL_FINALS', 'NATIONAL_FINALS_GROUP'].includes(scope.row.lastRaceSchedule.scheduleFlag)" type="success" size="small">已完成</el-tag>
              <el-tag v-else type="warning" size="small">未完成</el-tag>
            </template>
            <el-tag v-else type="info" size="small">未参赛</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="showOperationColumn" label="操作" width="80px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showDetailsClicked(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryForm.pageNum"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 选择新增类型的dialog -->
    <el-dialog
      title="选择新增类型"
      :visible.sync="addTypeSelectDialogVisible"
      width="480px"
      center
      :close-on-click-modal="false"
    >
      <div class="select-type-container">
        <div class="type-card" @click="selectBatchAdd">
          <div class="type-icon">
            <i class="el-icon-upload2"></i>
          </div>
          <div class="type-title">批量新增</div>
          <div class="type-desc">通过Excel模板批量导入用户数据</div>
        </div>
        <div class="type-card" @click="selectSingleAdd">
          <div class="type-icon">
            <i class="el-icon-plus"></i>
          </div>
          <div class="type-title">单项新增</div>
          <div class="type-desc">手动填写表单添加单个用户</div>
        </div>
      </div>
    </el-dialog>

    <!-- 批量新增的dialog -->
    <el-dialog
      title="批量新增用户"
      :visible.sync="batchAddDialogVisible"
      width="600px"
      center
      :close-on-click-modal="false"
    >
      <div class="batch-add-container">
        <div class="batch-steps">
          <el-steps :active="batchStep" align-center>
            <el-step title="下载模板" description="获取导入模板"></el-step>
            <el-step title="上传文件" description="选择填写好的文件"></el-step>
            <el-step title="确认导入" description="检查并确认导入数据"></el-step>
          </el-steps>
        </div>

        <div class="batch-content">
          <!-- 步骤1：下载模板 -->
          <div v-if="batchStep === 0" class="step-content">
            <div class="step-icon">
              <i class="el-icon-download"></i>
            </div>
            <h3>选择导入方式</h3>
            <p>您可以先下载模板按格式填写，或者直接上传已准备好的Excel文件</p>
            <div class="template-actions">
              <el-button type="primary" @click="downloadTemplate" icon="el-icon-download">
                下载模板
              </el-button>
              <el-button type="success" @click="skipToUpload" icon="el-icon-upload2">
                直接上传
              </el-button>
            </div>
          </div>

          <!-- 步骤2：上传文件 -->
          <div v-if="batchStep === 1" class="step-content">
            <el-upload
              class="upload-demo"
              drag
              :action="''"
              ref="importWordExcelRef"
              :auto-upload="false"
              :file-list="uploadFileList"
              :before-upload="beforeUpload"
              :on-change="handleFileChange"
              :on-remove="handleFileRemove"
              accept=".xlsx,.xls"
              :limit="1"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
              <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件。</div>
              <div class="el-upload__tip" slot="tip" style="color: red;">
                excel导入的信息,如果已经注册过,会覆盖原有信息,系统学校名称字段要与B端已有的学校名称一致
              </div>

              <!-- 自定义文件列表模板 -->
              <div slot="file" slot-scope="{file}">
                <div class="custom-file-item">
                  <div class="file-info">
                    <i class="el-icon-document file-icon"></i>
                    <span class="file-name">{{ file.name }}</span>
                  </div>
                  <div class="file-actions">
                    <!-- 显示绿色完成图标 -->
                    <i class="el-icon-circle-check success-icon" v-if="file.status === 'ready'"></i>
                    <!-- 移除按钮 -->
                    <i class="el-icon-close remove-icon" @click="handleFileRemove(file, uploadFileList)"></i>
                  </div>
                </div>
              </div>
            </el-upload>
          </div>

          <!-- 步骤3：确认导入 -->
          <div v-if="batchStep === 2" class="step-content">
            <p v-if="uploadedFileName">已选择文件：<span class="highlight">{{ uploadedFileName }}</span></p>
            <div style="margin: 20px 0;">
              <el-select
                placeholder="请选择赛区（必选）"
                style="width: 100%;"
                v-model="importWordExcel.districtId"
                clearable
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>

            <el-button type="success" @click="confirmUpload" icon="el-icon-check">
              确认导入
            </el-button>
          </div>

        </div>

        <div class="batch-actions">
          <el-button v-if="batchStep > 0" @click="prevStep">上一步</el-button>
          <el-button v-if="batchStep === 1 && uploadedFileName" type="primary" @click="nextStep">下一步</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 新增用户的dialog -->
    <el-dialog
      title="单项新增用户"
      :visible.sync="addUserDialogVisible"
      width="700px"
      center
      :close-on-click-modal="false"
      @close="addUserDialogClose"
    >
      <div class="single-add-container">
        <div class="add-user-header">
          <div class="header-icon">
            <i class="el-icon-user-solid"></i>
          </div>
          <div class="header-text">
            <h3>添加用户信息</h3>
            <p>请填写用户的基本信息，可添加多个用户</p>
          </div>
        </div>

        <el-form
          :model="addInfoForm"
          label-width="100px"
          ref="addInfoFormRef"
          :rules="addInfoRules"
          class="user-form"
        >
          <div class="user-list">
            <div
              v-for="(item, index) in addInfoForm.addUserList"
              :key="index"
              class="user-item"
            >
              <div class="user-item-header">
                <span class="user-number">用户 {{ index + 1 }}</span>
                <div class="action-buttons">
                  <el-button
                    v-if="(index + 1) === addInfoForm.addUserList.length"
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    circle
                    @click="addClicked"
                    title="添加用户"
                  ></el-button>
                  <el-button
                    v-if="addInfoForm.addUserList.length > 1"
                    type="danger"
                    size="mini"
                    icon="el-icon-minus"
                    circle
                    @click="subtractClicked(index)"
                    title="删除用户"
                  ></el-button>
                </div>
              </div>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item
                    label="手机号"
                    :prop="`addUserList.${index}.phone`"
                    :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' }]"
                  >
                    <el-input
                      v-model="item.phone"
                      placeholder="请输入手机号"
                      prefix-icon="el-icon-phone"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="姓名"
                    :prop="`addUserList.${index}.userName`"
                    :rules="[{ required: true, message: '请输入姓名', trigger: 'blur' }]"
                  >
                    <el-input
                      v-model="item.userName"
                      placeholder="请输入姓名"
                      prefix-icon="el-icon-user"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUserInfoClicked" icon="el-icon-check">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 编辑信息的dialog -->
    <el-dialog
      title="添加注册信息"
      :visible.sync="editInfoDialogVisible"
      width="60%"
      @close="editInfoDialogClose"
    >
      <el-form
        :model="editInfoForm"
        label-width="100px"
        ref="editInfoFormRef"
        :rules="editInfoRules"
        style="width: 100%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="editInfoForm.phone" placeholder="请输入">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名" prop="userName">
              <el-input
                v-model="editInfoForm.userName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="cardType">
              <el-select
                placeholder="请选择"
                v-model="editInfoForm.cardType"
                style="width: 100%"
              >
                <el-option
                  v-for="item in card_type"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号码" prop="idCard">
              <el-input
                style="width: 100%"
                v-model="editInfoForm.idCard"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="出生日期" prop="dateBirth">
              <el-date-picker
                :picker-options="pickerOptions"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="editInfoForm.dateBirth"
                type="date"
                placeholder="选择日期"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-select
                placeholder="请选择"
                v-model="editInfoForm.sex"
                style="width: 100%"
              >
                <el-option
                  v-for="item in e_sex"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="editInfoForm.email"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学校地区" prop="schoolArea">
              <el-cascader
                placeholder="请选择"
                v-model="editInfoForm.schoolArea"
                ref="schoolAreaRef"
                :options="areasData"
                style="width: 100%"
                :props="{
                  expandTrigger: 'hover',
                  label: 'name',
                  value: 'areaId',
                  children: 'areas',
                }"
                @change="provincesHandleChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学校" prop="schoolId">
              <el-select
                ref="mailingInfoModelSchoolSelectRef"
                style="width: 100%"
                placeholder="请选择"
                v-model="editInfoForm.schoolId"
                clearable
                filterable
              >
                <el-option
                  v-for="item in provincesSchoolList"
                  :key="item.id"
                  :label="item.schoolName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年级" prop="grade">
              <el-select
                style="width: 100%"
                placeholder="请选择年级"
                v-model="editInfoForm.grade"
                clearable
                @change="userGradeselectClicked"
              >
                <el-option
                  v-for="item in dict_grade"
                  :key="item.dictCode"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editInfoDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editInfo">保 存</el-button>
      </span>
    </el-dialog>
    </template>
    <template v-if="isZCUser">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item>C端数据管理</el-breadcrumb-item>
              <el-breadcrumb-item>用户信息</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="pm_goBack"></el-page-header>
        <!-- 筛选 -->
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col>
                    <span class="title_class">订单筛选</span>
                </el-col>
            </el-row>
            <el-form
                :model="pm_queryForm"
                class="filter_Form"
                label-width="120px"
                ref="pm_queryFormRef"
            >
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item label="所属赛区" prop="districtId">
                            <el-select
                                placeholder="请选择"
                                style="width: 100%"
                                v-model="pm_queryForm.districtId"
                                clearable
                                multiple
                            >
                                <el-option
                                    v-for="item in pm_dict_district"
                                    :key="item.id"
                                    :label="item.districtName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="学校" prop="schoolId">
                            <el-select
                                ref="pm_schoolSelectRef"
                                style="width: 100%"
                                placeholder="请选择"
                                v-model="pm_queryForm.schoolId"
                                clearable
                                filterable
                            >
                                <el-option
                                    v-for="item in pm_provincesSchoolList"
                                    :key="item.id"
                                    :label="item.schoolName"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                      <el-col :span="8">
                        <el-form-item label="姓名" prop="userName">
                            <el-input
                                v-model="pm_queryForm.userName"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="手机号" prop="phone">
                            <el-input
                                v-model="pm_queryForm.phone"
                                placeholder="请输入"
                                clearable
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" type="flex" justify="end">
                    <el-col :span="2">
                        <el-button
                            type="primary"
                            style="width: 100%"
                            @click="pm_getDataList('search')"
                            >查询</el-button
                        >
                    </el-col>
                    <el-col :span="2">
                        <el-button
                            type="primary"
                            style="width: 100%"
                            @click="pm_reset"
                            >重置</el-button
                        >
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <!-- 订单列表 -->
        <el-card class="list_card" style="margin-top: 20px">
            <el-row class="title_row">
                <el-col :span="12">
                    <div class="list_title title_class">订单列表</div>
                </el-col>
                <!-- <el-col :span="12">
                    <div style="text-align: right">
                        <el-button type="primary" @click="pm_showModel"
                            >批量发货</el-button
                        >
                        <el-button type="primary" @click="pm_exportOrderList"
                            >导出订单</el-button
                        >
                    </div>
                </el-col> -->
            </el-row>
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="pm_dataList"
                border
                stripe
            >
                <el-table-column label="序号" type="index"></el-table-column>
                <!-- <el-table-column
                    label="商户类型"
                    prop="merchantType"
                    :formatter="pm_merchantTypeFormatter"
                ></el-table-column> -->
                <el-table-column label="赛季" prop="season"></el-table-column>
                <el-table-column
                    label="赛区"
                    prop="districtName"
                ></el-table-column>
                <el-table-column
                    label="订单名称"
                    prop="orderName"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    label="订单号"
                    prop="orderNo"
                ></el-table-column>
                <el-table-column
                    label="姓名"
                    prop="userName"
                    width="120px"
                >
                <template slot-scope="scope">
                        <div style="display: flex;flex-direction: column; align-items: center">
                          <div style="font-size: 14px;font-weight: bold; color: #000;">{{ scope.row.userName }}</div>
                        </div>
                    </template>
              </el-table-column>
              <el-table-column
                    label="性别"
                    prop="sex"
                >
                  <template slot-scope="scope">
                    {{ scope.row.sex === "1" ? '男' : '女' }}
                  </template>
              </el-table-column>
                <el-table-column
                    label="手机号"
                    prop="phone"
                >
                  <template slot-scope="scope">
                    <MaskedPhone :phone="scope.row.phone" />
                  </template>
              </el-table-column>
                <el-table-column
                    label="年级"
                    prop="grade"
                >
                <template slot-scope="scope">
                    {{ scope.row.grade }}年级
                </template>
              </el-table-column>
                <el-table-column
                    label="学校名称"
                    prop="schoolName"
                ></el-table-column>
                <!-- <el-table-column
                    label="订单金额"
                    prop="orderAmount"
                    width="100px"
                ></el-table-column> -->
                <el-table-column
                    label="支付金额"
                    prop="orderAmount"
                    width="140px"
                >
                <template slot-scope="scope">
                        <div>
                          <div style="color: red">实际支付：{{ scope.row.paymentAmount ? scope.row.paymentAmount : '-'}}</div>
                          <div style="color: blue">补充支付：{{ scope.row.topUpAmount || '-' }}</div>
                          <div style="color: green">订单合计：{{ pm_totalAmount(scope.row) }}</div>
                        </div>
                    </template>
              </el-table-column>
                <!-- <el-table-column
                    label="订单来源"
                    prop="orderSource"
                    :formatter="pm_sourceFormatter"
                >
                </el-table-column>
                <el-table-column
                    label="下单时间"
                    prop="orderTime"
                ></el-table-column> -->
                <!-- <el-table-column label="是否发货" prop="sendStatus" width="100px">
                    <template slot-scope="scope">
                        <el-tag
                            type="success"
                            v-if="scope.row.sendStatus"
                            size="mini"
                            >已发货</el-tag
                        >
                        <el-tag type="warning" v-else size="mini"
                            >未发货</el-tag
                        >
                    </template>
                </el-table-column> -->
                <el-table-column
                    label="订单状态"
                    prop="scheduleProgress"
                    width="100px"
                    :formatter="pm_scheduleProgressFormatter"
                >
                    <template slot-scope="scope">
                        <el-tag
                            v-if="scope.row.refundAmount && scope.row.refundAmount !== 0"
                            type="danger"
                            size="mini"
                        >已退款</el-tag>
                        <el-tag
                            v-else
                            :type="scope.row.scheduleProgress === '订单已完成' ? 'success' : scope.row.scheduleProgress === '使用中' ? 'warning' : scope.row.scheduleProgress === '订单未开始' ? 'info' : 'danger'"
                            size="mini"
                            >{{
                                scope.row.scheduleProgress
                            }}</el-tag
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    label="退费金额"
                    prop="refundAmount"
                >
                    <template slot-scope="scope">
                        <div>
                            <span
                                style="color: rgb(255, 0, 0); font-size: 14px"
                                >{{
                                    scope.row.refundAmount
                                        ? '￥' + scope.row.refundAmount
                                        : '-'
                                }}</span
                            >
                        </div>
                        <!-- <div>
                            <span style="color: #999; font-size: 12px">{{
                                scope.row.refundTime ? scope.row.refundTime : ''
                            }}</span>
                        </div> -->
                    </template>
                </el-table-column>
                <!-- <el-table-column label="备注" prop="remark">
                    <template slot-scope="scope">
                        <el-tooltip
                            v-if="scope.row.remark"
                            class="item"
                            effect="dark"
                            :content="scope.row.remark"
                            placement="top"
                        >
                            <span class="remark-ellipsis">
                                {{ scope.row.remark }}
                            </span>
                        </el-tooltip>
                        <span v-else>-</span>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="操作" width="120px" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="pm_showProductDetailDialog(scope.row)"
                            >查看详情</el-button
                        >
                        <el-button
              v-if="
                (scope.row.orderStatus &&
                scope.row.orderStatus + '' === '4') && (scope.row.isSend &&
                scope.row.isSend + '' === '1') && scope.row.sendStatus !== true
              "
              type="text"
              size="small"
              @click="pm_showSendProductDetailDialogClicked(scope.row)"
              >发货</el-button
            >
                    </template>
                </el-table-column> -->
            </el-table>
            <!-- 分页 -->
            <el-pagination
                @size-change="pm_handleSizeChange"
                @current-change="pm_handleCurrentChange"
                :current-page="pm_queryForm.pageNum"
                :page-sizes="[10, 20, 40, 80]"
                :page-size="pm_queryForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pm_total"
            >
            </el-pagination>
        </el-card>
        <!-- 审核弹窗 -->
        <el-dialog
            title="审核"
            :visible.sync="pm_auditVisible"
            @close="pm_hideAuditFn"
            width="500px"
        >
            <el-form label-width="100px" style="width: 100%">
                <el-form-item label="退费类型" prop="">
                    <el-tag type="primary" size="mini">{{
                        pm_refundInfo.refundType === 0 ? "仅退款" : "退货退款"
                    }}</el-tag>
                </el-form-item>
                <el-form-item
                    label="货物状态"
                    prop=""
                    v-if="pm_refundInfo.refundType === 0"
                >
                    <el-tag
                        :type="
                            pm_refundInfo.cargoStatus === 0 ? 'danger' : 'success'
                        "
                        size="mini"
                        >{{
                            pm_refundInfo.cargoStatus === 0
                                ? "未收到货"
                                : "已收到货"
                        }}</el-tag
                    >
                </el-form-item>
                <el-form-item
                    label="退货方式"
                    prop=""
                    v-if="pm_refundInfo.refundType === 1"
                >
                    <el-tag type="warning" size="mini">自行寄回</el-tag>
                </el-form-item>
                <el-form-item label="退费金额" prop="">
                    <div class="price">¥{{ pm_refundInfo.refundApplyAmount }}</div>
                </el-form-item>
                <el-form-item label="退费原因" prop="" class="bb">
                    <div class="reason-area">
                        {{ pm_refundInfo.refundApplyReason }}
                    </div>
                </el-form-item>

                <el-form-item label="审核" prop="">
                    <el-radio
                        v-model="pm_refundInfo.refundApplyForStatus"
                        :label="1"
                        @input="pm_auditRadioChange"
                        >通过</el-radio
                    >
                    <el-radio
                        v-model="pm_refundInfo.refundApplyForStatus"
                        :label="2"
                        @input="pm_auditRadioChange"
                        >不通过</el-radio
                    >
                </el-form-item>
                <el-form-item
                    label="退费金额"
                    prop=""
                    v-if="
                        pm_refundInfo.refundApplyForStatus === 1 &&
                        pm_refundInfo.refundType === 0
                    "
                >
                    ¥
                    <el-input
                        style="width: 100px"
                        type="text"
                        v-model="pm_refundApplyAmount"
                    />
                </el-form-item>
                <el-form-item
                    label="原因"
                    prop=""
                    v-if="
                        pm_refundInfo.refundApplyForStatus === 2 ||
                        (pm_refundInfo.refundApplyForStatus === 1 &&
                            pm_refundInfo.refundType === 0)
                    "
                >
                    <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入审核不通过原因"
                        v-model="pm_refundInfo.reasonRefundReview"
                    >
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="pm_auditVisible = false">取 消</el-button>
                <el-button type="primary" @click="pm_handleToAudit"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!-- 确认收货弹窗 -->
        <el-dialog
            title="确认收货"
            :visible.sync="pm_confirmVisible"
            @close="pm_hideConfirmFn"
            width="500px"
        >
            <el-form label-width="80px" style="width: 100%">
                <el-form-item label="申请退款" prop="">
                    ¥{{ pm_refundInfo.refundApplyAmount }}
                    <el-button type="text" size="small" @click="pm_changeSumFn"
                        >修改</el-button
                    >
                </el-form-item>
                <el-form-item label="实际退款" prop="" v-if="pm_changeSum">
                    ¥
                    <el-input
                        type="text"
                        style="width: 100px"
                        v-model="pm_refundApplyAmount"
                    ></el-input>
                </el-form-item>
                <el-form-item label="修改原因" prop="" v-if="pm_changeSum">
                    <el-input
                        type="textarea"
                        :rows="3"
                        v-model="pm_confirmReceiptGoodsReason"
                        placeholder="请输入原因"
                    >
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="pm_confirmVisible = false">取 消</el-button>
                <el-button
                    type="primary"
                    @click="pm_sellerConfirmsReceiptOfGoodsFn(1)"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!-- 拒绝收货弹窗 -->
        <el-dialog
            title="拒绝收货"
            :visible.sync="pm_refuseVisible"
            @close="pm_hideRefuseFn"
            width="500px"
        >
            <el-form label-width="80px" style="width: 100%">
                <el-form-item label="申请退款" prop="">
                    ¥{{ pm_refundInfo.refundApplyAmount }}
                </el-form-item>
                <el-form-item label="拒绝原因" prop="">
                    <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入原因"
                        v-model="pm_confirmReceiptGoodsReason"
                    >
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="pm_refuseVisible = false">取 消</el-button>
                <el-button
                    type="primary"
                    @click="pm_sellerConfirmsReceiptOfGoodsFn(0)"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!-- 填写快递信息弹窗 -->
        <el-dialog
            title="快递信息"
            :visible.sync="pm_showSendProductDetailDialogVisible"
            @close="pm_showSendProductDetailDialogClose"
            width="500px"
        >
            <el-form
                :model="pm_sendProductForm"
                label-width="100px"
                ref="pm_sendProductFormRef"
                :rules="pm_sendProductInfoRules"
                style="width: 100%"
            >
                <el-form-item label="快递公司" prop="expressType">
                    <el-select
                        placeholder="请选择"
                        v-model="pm_sendProductForm.expressType"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in pm_dict_express"
                            :key="item.dictValue"
                            :label="item.dictLabel"
                            :value="item.dictValue"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="快递单号" prop="expressNumber">
                    <el-input
                        type="textarea"
                        v-model="pm_sendProductForm.expressNumber"
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="pm_showSendProductDetailDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="pm_subSendProductMessage"
                    >确 定</el-button
                >
            </span>
        </el-dialog>

        <!-- 批量发货 -->
        <el-dialog
            title="批量发货"
            :visible.sync="pm_dialogVisible"
            @close="pm_handleToCloseModel"
            width="550px"
        >
            <el-row>
                <el-col :span="24" class="row"
                    >1. 先筛选出需要发货的订单并导出</el-col
                >
                <el-col :span="24" class="row"
                    >2.
                    编辑导出的文件，在最后两列补充"快递公司"和"快递单号"并上传</el-col
                >
                <el-col :span="24" class="row"
                    >3.
                    "快递公司"一列填写示例：顺丰快递/德邦快递/中通快递/申通快递/邮政快递/韵达快递/汇通快递/圆通快递/京东快递/极兔速递。暂不识别其他快递</el-col
                >
            </el-row>

            <el-upload
                ref="pm_uploadFileRef"
                :action="pm_uploadInfo.uploadUrl"
                :headers="pm_uploadInfo.headerObj"
                :before-upload="pm_beforeUpload"
                :limit="1"
                :on-success="pm_uploadSuccess"
                :on-error="pm_uploadError"
            >
                <el-button type="primary">点击上传</el-button>
            </el-upload>
        </el-dialog>
    </template>
  </div>
</template>

<script>
// saveSysUserByPhone
import { getAllAreaList, getAvaTbOrderList, getSysUserList, getSchoolListWithCity, saveSysUserAll, queryDistrictPage, saveSysUserBatch, excelTbOrderList, fillInTheTrackingNumber, getFlagListData, executionOrderCompletion, orderRefundReviewInfo, orderRefundReview, sellerConfirmsReceiptOfGoods, financialAuditRefund } from '@/http/api'
export default {
  data () {
    return {
      addUserDialogVisible: false,
      addTypeSelectDialogVisible: false,
      batchAddDialogVisible: false,
      batchStep: 0, // 批量新增步骤
      uploadedDataCount: 0, // 上传的数据条数
      uploadedFileName: '', // 上传的文件名
      selectedFile: null, // 选择的文件对象
      uploadFileList: [], // 上传组件的文件列表
      dict_district: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      },
      timer: new Date().getTime(),
      addInfoForm: {
        addUserList: [
          {
            phone: '',
            userName: ''
          }
        ]
      },
      importWordExcel: {
        uploadUrl: this.$env.baseIP + 'erpUser/importSysUserBatch',
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        },
        districtId: null
      },
      queryForm: {
        phone: '',
        name: '',
        identity: 0,
        schoolId: '',
        pageNum: 1,
        pageSize: 10
      },
      schoolArea: null,
      editInfoForm: {
        phone: '',
        userName: '',
        sex: '',
        cardType: '',
        email: '',
        idCard: '',
        dateBirth: '',
        schoolArea: [],
        schoolId: '',
        grade: ''
      },
      addInfoRules: {
        'addUserList.phone': [{ required: true, message: '请输入手机号', trigger: 'blur' }]
      },

      editInfoRules: {
        phone: [{ required: true, message: '请输入', trigger: 'blur' }],
        userName: [{ required: true, message: '请输入', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择', trigger: 'change' }],
        cardType: [{ required: true, message: '请选择', trigger: 'change' }],
        email: [{ required: true, message: '请输入', trigger: 'blur' }],
        idCard: [{ required: true, message: '请输入', trigger: 'blur' }],
        dateBirth: [{ required: true, message: '请选择', trigger: 'change' }],
        schoolArea: [{ required: true, message: '请选择', trigger: 'change' }],
        schoolId: [{ required: true, message: '请选择', trigger: 'change' }],
        grade: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      editInfoSchoolList: [], // 学校数组
      editInfoDialogVisible: false,
      isZCUser: this.$store && this.$store.state.loginPhone === '18611955177' && this.$store.state.flag === 'ZC',
      total: 0,
      dict_group: this.$userInfo.dict_group(),
      e_sex: this.$userInfo.getDataList(this, 'e_sex').then(value => { this.e_sex = value }),
      card_type: this.$userInfo.getDataList(this, 'card_type').then(value => { this.card_type = value }),
      dict_grade: this.$userInfo.getGradeData(),
      dataList: [],
      areasData: [],
      provincesSchoolList: [],
      provincesSchoolListSearch: [],
      // ===== product_management data (pm_ 前缀) =====
      pm_showSendProductDetailDialogVisible: false,
      pm_sendProductForm: {
        expressType: '',
        expressNumber: ''
      },
      pm_productList: [],
      pm_areasData: [],
      pm_dataList: [],
      pm_e_sex: this.$userInfo.getDataList(this, 'e_sex').then(value => { this.pm_e_sex = value }),
      pm_dict_express: this.$userInfo.getDataList(this, 'express_type').then(value => { this.pm_dict_express = value }),
      pm_dict_district: [],
      pm_dict_season: this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => { this.pm_dict_season = value }),
      pm_dict_merchantType: this.$userInfo.getDataList(this, 'dict_merchantType').then(value => { this.pm_dict_merchantType = value }),
      pm_order_source: this.$userInfo.orderSource(),
      pm_order_status: this.$userInfo.orderStatus(),
      pm_dict_boolData: this.$userInfo.dict_boolData(),
      pm_dict_nullDistrictStates: this.$userInfo.nullDistrictStates(),
      pm_order_payType: this.$userInfo.order_payType(),
      pm_sendProductInfoRules: {
        expressType: [{ required: true, message: '请选择', trigger: 'change' }],
        expressNumber: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      pm_provincesSchoolList: [],
      pm_queryForm: {
        userName: '',
        orderSource: '',
        orderStatus: '',
        season: this.$chnEngStatusCode.defaultSeason,
        sendStatus: null,
        phone: '',
        pageNum: 1,
        pageSize: 10,
        orderNo: null,
        orderStartTime: '',
        orderEndTime: '',
        nullDistrict: false
      },
      pm_total: 0,
      pm_orderTimeRange: [],
      pm_dialogVisible: false,
      pm_uploadInfo: {
        uploadUrl: `${this.$http.defaults.baseURL}order/importSendGoodsTbOrderList`,
        headerObj: {
          Authorization: localStorage.getItem('Authorization')
        }
      },
      pm_auditVisible: false,
      pm_confirmVisible: false,
      pm_refuseVisible: false,
      pm_changeSum: false,
      pm_refundInfo: {},
      pm_refundApplyAmount: '',
      pm_confirmReceiptGoodsReason: ''
    }
  },
  computed: {
    // 是否需要显示操作列：身份为 ZC 且手机号为 18611955177 时隐藏，其他情况显示
    showOperationColumn () {
      return !(this.$store && this.$store.state.loginPhone === '18611955177' && this.$store.state.flag === 'ZC')
    }
  },
  created () {
    if (this.isZCUser) {
      this.pm_getDistrictList()
      this.pm_getFlagList()
      this.pm_getSchoolListData()
      this.pm_getDataList()
    } else {
      this.getDataList()
      this.getDistrictList()
      this.getAllAreaList()
    }
  },
  activated () {
    if (this.isZCUser) {
      if (this.$route.query.type === '1') {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const yesterday = new Date(today)
        yesterday.setDate(yesterday.getDate() - 1)
        this.pm_orderTimeRange = [yesterday, today]
        this.pm_queryForm.orderStartTime = this.$moment(yesterday).format('YYYY-MM-DD HH:mm:ss')
        this.pm_queryForm.orderEndTime = this.$moment(today).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.pm_orderTimeRange = []
        this.pm_queryForm.orderStartTime = ''
        this.pm_queryForm.orderEndTime = ''
      }
      this.pm_getDataList()
    }
  },
  methods: {
    // 添加选手信息
    addClicked () {
      this.addInfoForm.addUserList.push({
        phone: '',
        userName: ''
      })
    },
    // 减少选手信息
    subtractClicked (e) {
      console.log('e', e)
      this.addInfoForm.addUserList.splice(e, 1)
    },
    getAllAreaList () {
      getAllAreaList({}).then((res) => {
        this.areasData = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    goBack () {
      this.$router.back()
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 获取列表信息
    getDataList (getType) {
      if (getType === 'search') {
        this.queryForm.pageNum = 1
        this.queryForm.pageSize = 10
      }
      getSysUserList(this.queryForm).then((res) => {
        console.log('getDataList', res)
        this.dataList = res.data.list
        this.total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    editExamineeTypeClicked () {
      this.editInfoDialogVisible = true
    },
    // 学校省市区选择
    provincesHandleChange (value) {
      if (!value) return
      this.provincesSchoolList = []
      this.editInfoForm.schoolName = ''
      this.editInfoForm.schoolId = ''
      this.editInfoForm.provinceCode = value[0]
      this.editInfoForm.cityCode = value[1]
      this.editInfoForm.areaCode = value[2]
      const deliveryAreaName = this.$refs.schoolAreaRef.getCheckedNodes()[0].pathLabels.join('/')
      const areaList = deliveryAreaName.split('/')
      this.editInfoForm.province = areaList[0]
      this.editInfoForm.city = areaList[1]
      this.editInfoForm.area = areaList[2]
      console.log('editInfoForm', this.editInfoForm)
      this.getSchoolListData(value, 2)
    },
    // 获取学校List
    getSchoolListData (schoolArea, type) {
      getSchoolListWithCity({ provinceCode: schoolArea[0], cityCode: schoolArea[1], areaCode: schoolArea[2] }).then((res) => {
        console.log('getSchoolList', res)
        if (type === 1) {
          this.provincesSchoolListSearch = res.data
        } else if (type === 2) {
          this.provincesSchoolList = res.data
        }
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 用户年级选择转换组别
    userGradeselectClicked () {
      const gradeData = this.$userInfo.getUserGroupWithGrade(this.editInfoForm.grade)
      this.editInfoForm.group = gradeData.userGradeStr
      this.editInfoForm.level = gradeData.groupId
    },
    // 查看用户详情
    showDetailsClicked (rowData) {
      console.log('rowData', rowData)
      this.$router.push(
        {
          path: '/c_data_Management/c_player_registInfo_details',
          query: {
            userId: rowData.id
          }
        }
      )
    },
    // 保存用户信息
    editInfo () {
      this.$refs.editInfoFormRef.validate(async valid => {
        if (!valid) return
        if (!this.$xcUtils.checkPhone(this.editInfoForm.phone)) return this.$message.warning('请输入正确手机号')
        if (this.editInfoForm.cardType === '1') {
          if (!this.$xcUtils.checkIdCard(this.editInfoForm.idCard)) return this.$message.warning('请输入正确证件号')
        }
        if (!this.$xcUtils.checkEmail(this.editInfoForm.email)) return this.$message.warning('请输入正确邮箱')
        this.editInfoForm.schoolName = this.$refs.mailingInfoModelSchoolSelectRef.selectedLabel
        var sysUserDto = {}
        sysUserDto.cardType = this.editInfoForm.cardType
        sysUserDto.dateBirth = this.editInfoForm.dateBirth
        sysUserDto.email = this.editInfoForm.email
        sysUserDto.idCard = this.editInfoForm.idCard
        sysUserDto.phone = this.editInfoForm.phone
        sysUserDto.sex = this.editInfoForm.sex
        sysUserDto.userName = this.editInfoForm.userName
        var sysUserInfoDto = {}
        sysUserInfoDto.area = this.editInfoForm.area
        sysUserInfoDto.areaCode = this.editInfoForm.areaCode
        sysUserInfoDto.city = this.editInfoForm.city
        sysUserInfoDto.cityCode = this.editInfoForm.cityCode
        sysUserInfoDto.level = this.editInfoForm.level
        sysUserInfoDto.nationality = this.editInfoForm.nationality
        sysUserInfoDto.nationalityCode = this.editInfoForm.nationalityCode
        sysUserInfoDto.province = this.editInfoForm.province
        sysUserInfoDto.provinceCode = this.editInfoForm.provinceCode
        sysUserInfoDto.schoolId = this.editInfoForm.schoolId
        sysUserInfoDto.schoolName = this.editInfoForm.schoolName
        var saveForm = {}
        saveForm.sysUserDto = sysUserDto
        saveForm.sysUserInfoDto = sysUserInfoDto
        saveSysUserAll(saveForm).then((res) => {
          console.log('saveForm', res)
          this.editInfoDialogVisible = false
          this.$message.success('添加成功')
          this.getDataList()
        }).catch((err) => {
          console.log('err', err)
        })
      })
    },
    addUserClicked () {
      this.addTypeSelectDialogVisible = true
    },
    // 选择单项新增
    selectSingleAdd () {
      this.addTypeSelectDialogVisible = false
      this.addUserDialogVisible = true
    },
    // 选择批量新增
    selectBatchAdd () {
      this.addTypeSelectDialogVisible = false
      this.batchAddDialogVisible = true
    },
    // 下载模板
    downloadTemplate () {
      // 这里添加下载模板的逻辑
      var downLoadUrl = this.$env.baseIP + 'erpUser/downloadExcel'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', {})
      this.$message.success('模板下载成功')
      this.batchStep = 1 // 自动进入下一步
    },
    // 跳过下载直接上传
    skipToUpload () {
      this.batchStep = 1 // 直接进入上传步骤
    },
    // 上传前验证
    beforeUpload (file) {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                     file.type === 'application/vnd.ms-excel'

      if (!isExcel) {
        this.$message.error('只能上传Excel文件!')
        return false
      }

      return true
    },
    // 文件选择变化处理
    handleFileChange (file, fileList) {
      if (file.status === 'ready') {
        this.selectedFile = file.raw
        this.uploadedFileName = file.name
        this.uploadFileList = fileList // 保存文件列表状态
        this.$message.success('文件选择成功，请进入下一步进行确认导入')
      }
    },
    // 文件移除处理
    handleFileRemove (file, fileList) {
      this.selectedFile = null
      this.uploadedFileName = ''
      this.uploadFileList = fileList
    },
    // 上传成功
    uploadSuccess (response, file) {
      console.log('上传成功响应:', response)
      if (response && response.code === 200) {
        this.$message.success('文件上传并导入成功')
        // 直接关闭弹窗并刷新数据
        this.closeBatchDialog()
        this.getDataList('search')
      } else {
        this.$message.error(response.msg || '文件导入失败')
      }
    },
    // 上传失败
    uploadError (error) {
      console.log('上传失败:', error)
      this.$message.error('文件上传失败，请重试')
    },
    // 确认上传
    confirmUpload () {
      // 验证赛区是否选择
      if (!this.importWordExcel.districtId) {
        this.$message.warning('请选择赛区')
        return
      }

      // 验证文件是否选择
      if (!this.selectedFile) {
        this.$message.warning('请先选择要上传的文件')
        return
      }

      // 创建FormData对象进行文件上传
      const formData = new FormData()
      formData.append('file', this.selectedFile)
      formData.append('districtId', this.importWordExcel.districtId)

      // 使用axios进行文件上传
      this.$http.post(this.importWordExcel.uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...this.importWordExcel.headerObj
        }
      }).then(response => {
        console.log('上传成功响应:', response)
        if (response && response.code === 200) {
          this.$message.success('文件上传并导入成功')
          this.closeBatchDialog()
          this.getDataList('search')
        } else {
          this.$message.error(response.msg || '文件导入失败')
        }
      }).catch(error => {
        console.log('上传失败:', error)
        this.$message.error('文件上传失败，请重试')
      })
    },

    // 上一步
    prevStep () {
      if (this.batchStep > 0) {
        this.batchStep--
      }
    },
    // 下一步
    nextStep () {
      if (this.batchStep < 2) {
        this.batchStep++
      }
    },
    // 关闭批量新增弹窗
    closeBatchDialog () {
      this.batchAddDialogVisible = false
      this.batchStep = 0
      this.uploadedDataCount = 0
      this.uploadedFileName = ''
      this.selectedFile = null
      this.uploadFileList = [] // 清空文件列表
      this.importWordExcel.districtId = null
      // 清空上传组件
      if (this.$refs.importWordExcelRef) {
        this.$refs.importWordExcelRef.clearFiles()
      }
    },
    // 新增用户请求
    addUserInfoClicked () {
      console.log('this.addInfoForm', this.addInfoForm)
      saveSysUserBatch(this.addInfoForm.addUserList).then((res) => {
        this.addUserDialogVisible = false
        this.$message.success('添加成功')
        this.getDataList('search')
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    // 新增用户弹窗关闭
    addUserDialogClose () {
      this.$refs.addInfoFormRef.resetFields()
      this.addInfoForm = {
        addUserList: [
          {
            phone: '',
            userName: ''
          }
        ]
      }
    },
    // 重置搜索条件
    reset () {
      this.schoolArea = null
      this.$refs.queryFormRef.resetFields()
      this.getDataList()
    },
    handleSizeChange (newSize) {
      this.queryForm.pageSize = newSize
      this.getDataList()
    },
    handleCurrentChange (newCurPage) {
      this.queryForm.pageNum = newCurPage
      this.getDataList()
    },
    genderFormatter (data) {
      var temp = '未设置'
      for (const key in this.e_sex) {
        if (Object.hasOwnProperty.call(this.e_sex, key)) {
          const element = this.e_sex[key]
          if (element.dictValue + '' === data.sex + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    cardTypeFormatter (data) {
      var temp = '未设置'
      for (const key in this.card_type) {
        if (Object.hasOwnProperty.call(this.card_type, key)) {
          const element = this.card_type[key]
          if (element.dictValue + '' === data.cardType + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    groupFormatter (data) {
      var temp = '未设置'
      for (const key in this.dict_group) {
        if (Object.hasOwnProperty.call(this.dict_group, key)) {
          const element = this.dict_group[key]
          if (element.dictValue === data.level) {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    gradeFormatter (data) {
      var temp = '未设置'
      for (const key in this.dict_grade) {
        if (Object.hasOwnProperty.call(this.dict_grade, key)) {
          const element = this.dict_grade[key]
          if (element.dictValue === data.grade + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    editInfoDialogClose () {
      this.$refs.editInfoFormRef.resetFields()
    },
    exportTable () {
      const { pageNum, pageSize, ...newForm } = this.queryForm
      const downLoadUrl = `${this.$http.defaults.baseURL}erpUser/excelQuerySysUserList?${this.$xcUtils.serialize(newForm)}`
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl)
    },
    // 学校省市区选择
    provincesHandleChangeSearch (value) {
      console.log('value', value)
      if (!value) return
      this.provincesSchoolListSearch = []
      this.queryForm.schoolId = ''
      this.getSchoolListData(value, 1)
    },
    // ===== product_management methods (pm_ 前缀) =====
    pm_goBack () {
      this.$router.back()
    },
    pm_totalAmount (item) {
      return item.paymentAmount ? (item.topUpAmount ? (Number(item.topUpAmount) + Number(item.paymentAmount)).toFixed(2) : (Number(item.paymentAmount)).toFixed(2)) : '-'
    },
    pm_getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.pm_dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    pm_getFlagList () {
      getFlagListData(this.pm_queryForm).then((res) => {
        console.log('getFlagListData', res)
        this.pm_productList = res.data
      }).catch((err) => {
        console.log('err', err)
      })
    },
    pm_getDataList (getType) {
      if (getType === 'search') {
        this.pm_queryForm.pageNum = 1
      }
      getAvaTbOrderList(this.pm_queryForm).then((res) => {
        console.log('getAvaTbOrderList', res)
        this.pm_dataList = res.data.list
        this.pm_total = res.data.total
      }).catch((err) => {
        console.log('err', err)
      })
    },
    pm_getSchoolListData (schoolArea) {
      getSchoolListWithCity({ pageNum: 1, pageSize: 10000 }).then((res) => {
        console.log('getSchoolList', res)
        this.pm_provincesSchoolList = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    pm_reset () {
      this.pm_orderTimeRange = []
      this.pm_queryForm.orderStartTime = ''
      this.pm_queryForm.orderEndTime = ''
      this.$refs.pm_queryFormRef.resetFields()
      this.pm_getDataList()
    },
    pm_handleSizeChange (newSize) {
      this.pm_queryForm.pageSize = newSize
      this.pm_getDataList()
    },
    pm_handleCurrentChange (newCurPage) {
      this.pm_queryForm.pageNum = newCurPage
      this.pm_getDataList()
    },
    pm_showProductDetailDialog (data) {
      this.$route.meta.isPush = false
      this.$router.push(
        {
          path: '/product_Management/product_detail_management',
          query: {
            order_no: data.orderNo,
            user_id: data.userId
          }
        }
      )
    },
    pm_showSendProductDetailDialogClicked (rowData) {
      console.log('rowData', rowData)
      this.pm_sendProductForm.userId = rowData.userId
      this.pm_sendProductForm.orderNo = rowData.orderNo
      this.pm_showSendProductDetailDialogVisible = true
    },
    pm_subSendProductMessage () {
      this.$refs.pm_sendProductFormRef.validate(valid => {
        if (!valid) return
        fillInTheTrackingNumber(this.pm_sendProductForm).then((res) => {
          this.pm_showSendProductDetailDialogVisible = false
          this.$message.success('操作成功')
          this.pm_getDataList()
        }).catch((err) => {
          console.log('err', err)
        })
      })
    },
    pm_confirmReceiptGoods (rowData) {
      this.$confirm('是否确认用户已收到货物。', '提示', {
        confirmButtonText: '确认收到',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var formData = {
          orderNo: rowData.orderNo,
          userId: rowData.userId
        }
        executionOrderCompletion(formData).then((res) => {
          console.log('executionOrderCompletion', res)
          this.$message.success('操作成功')
          this.pm_getDataList()
        }).catch((err) => {
          console.log('err', err)
        })
      }).catch(() => {
      })
    },
    pm_showSendProductDetailDialogClose () {
      this.$refs.pm_sendProductFormRef.resetFields()
    },
    pm_exportOrderList () {
      excelTbOrderList(this.pm_queryForm).then((res) => {
        window.location.href = res.data
      }).catch((err) => {
        console.log('err', err)
      })
    },
    pm_showModel () {
      this.pm_dialogVisible = true
    },
    pm_handleToCloseModel () {
      this.pm_dialogVisible = false
    },
    pm_beforeUpload (file) {
      if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message.error('请选择excel文件上传')
        return false
      }
    },
    pm_uploadSuccess (res) {
      if (res.code === 200) {
        this.$message.success('批量发货成功')
        this.pm_dialogVisible = false
        this.pm_getDataList('search')
      } else {
        this.$message.error(res.msg)
      }
      this.$refs.pm_uploadFileRef.clearFiles()
    },
    pm_uploadError (error) {
      console.log('uploadError', error)
    },
    pm_downloadTemp () {
      const params = { ...this.pm_queryForm, ...{ orderStatus: '2' } }
      var downLoadUrl = this.$env.baseIP + 'order/excelTbOrderList'
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', params)
    },
    pm_sourceFormatter (data) {
      var temp = '未设置'
      for (const key in this.pm_order_source) {
        if (Object.hasOwnProperty.call(this.pm_order_source, key)) {
          const element = this.pm_order_source[key]
          if (element.dictValue === data.orderSource + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    pm_statusFormatter (data) {
      var temp = '未设置'
      for (const key in this.pm_order_status) {
        if (Object.hasOwnProperty.call(this.pm_order_status, key)) {
          const element = this.pm_order_status[key]
          if (element.dictValue === data.orderStatus + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    pm_merchantTypeFormatter (data) {
      var temp = '未分账'
      for (const key in this.pm_dict_merchantType) {
        if (Object.hasOwnProperty.call(this.pm_dict_merchantType, key)) {
          const element = this.pm_dict_merchantType[key]
          if (element.dictValue === data.merchantType + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    pm_findStatus (status) {
      return this.pm_order_status.find(item => item.dictCode === status)
    },
    pm_orderTimeChange (e) {
      console.log(e)
      if (e && e.length) {
        this.pm_queryForm.orderStartTime = this.$moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
        this.pm_queryForm.orderEndTime = this.$moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
      } else {
        this.pm_queryForm.orderStartTime = ''
        this.pm_queryForm.orderEndTime = ''
      }
    },
    pm_showAuditFn (item) {
      this.pm_refundInfo = item
      orderRefundReviewInfo({ userId: item.userId, orderNo: item.orderNo }).then(res => {
        this.pm_auditVisible = true
        this.pm_refundInfo = { ...this.pm_refundInfo, ...res.data }
      })
    },
    pm_hideAuditFn () {
      this.pm_auditVisible = false
    },
    pm_auditRadioChange (e) {
      if (e === 1) {
        this.pm_refundApplyAmount = this.pm_refundInfo.refundApplyAmount
      }
    },
    pm_handleToAudit () {
      const params = {
        orderNo: this.pm_refundInfo.orderNo,
        reasonRefundReview: this.pm_refundInfo.reasonRefundReview || '',
        refundApplyForStatus: this.pm_refundInfo.refundApplyForStatus,
        refundAuditAmount: this.pm_refundApplyAmount || this.pm_refundInfo.refundApplyAmount,
        userId: this.pm_refundInfo.userId
      }
      if (params.refundApplyForStatus === 1 || (params.refundApplyForStatus === 2 && params.reasonRefundReview)) {
        orderRefundReview(params).then(res => {
          if (res.code === 200) {
            this.$message.success('已审核')
            this.pm_getDataList()
            this.pm_hideAuditFn()
          }
        })
      }
    },
    pm_showConfirmFn (item) {
      this.pm_refundInfo = item
      this.pm_confirmReceiptGoodsReason = ''
      this.pm_refundApplyAmount = ''
      this.pm_changeSum = false
      orderRefundReviewInfo({ userId: item.userId, orderNo: item.orderNo }).then(res => {
        this.pm_confirmVisible = true
        this.pm_refundInfo = { ...this.pm_refundInfo, ...res.data }
      })
    },
    pm_hideConfirmFn () {
      this.pm_confirmVisible = false
    },
    pm_sellerConfirmsReceiptOfGoodsFn (type) {
      const params = {
        confirmReceiptGoods: type,
        confirmReceiptGoodsReason: this.pm_confirmReceiptGoodsReason,
        orderNo: this.pm_refundInfo.orderNo,
        refundApplyAmount: this.pm_refundApplyAmount || this.pm_refundInfo.refundApplyAmount,
        userId: this.pm_refundInfo.userId
      }
      sellerConfirmsReceiptOfGoods(params).then(res => {
        if (res.code === 200) {
          this.$message.success(`已${type === 1 ? '确认' : '拒绝'}收货`)
          this.pm_getDataList()
          if (type === 1) {
            this.pm_hideConfirmFn()
          } else {
            this.pm_hideRefuseFn()
          }
        }
      })
    },
    pm_refundSuccessFn (item) {
      this.$confirm('确认财务已打款？确认后用户将收到退款成功提示', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          orderNo: item.orderNo,
          refundApplyForReason: '',
          refundApplyForStatus: 1,
          userId: item.userId
        }
        financialAuditRefund(params).then(res => {
          if (res.code === 200) {
            this.pm_getDataList()
            this.$message.success('退款成功')
          }
        })
      }).catch(() => {
      })
    },
    pm_showRefuseFn (item) {
      this.pm_refundInfo = item
      this.pm_confirmReceiptGoodsReason = ''
      this.pm_refundApplyAmount = ''
      orderRefundReviewInfo({ userId: item.userId, orderNo: item.orderNo }).then(res => {
        this.pm_refuseVisible = true
        this.pm_refundInfo = { ...this.pm_refundInfo, ...res.data }
      })
    },
    pm_hideRefuseFn () {
      this.pm_refuseVisible = false
    },
    pm_changeSumFn () {
      this.pm_changeSum = !this.pm_changeSum
    },
    pm_genderFormatter (data) {
      var temp = '未设置'
      for (const key in this.pm_e_sex) {
        if (Object.hasOwnProperty.call(this.pm_e_sex, key)) {
          const element = this.pm_e_sex[key]
          console.log('element.dictValue', element.dictValue)
          if (element.dictValue + '' === data.sex + '') {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    pm_getAllAreaList () {
      getAllAreaList({}).then((res) => {
        this.pm_areasData = res.data
      }).catch((err) => {
        console.log('返回的err', err)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.div_algin_right {
  text-align: right;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
/* 选择类型弹窗样式 */
.select-type-container {
  display: flex;
  gap: 20px;
  padding: 20px 0;
}

.type-card {
  flex: 1;
  padding: 30px 20px;
  border: 2px solid #e6e6e6;
  border-radius: 12px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #fafafa;
}

.type-card:hover {
  border-color: #409eff;
  background: #ecf5ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
}

.type-icon {
  font-size: 48px;
  color: #409eff;
  margin-bottom: 15px;
}

.type-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.type-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

/* 批量新增弹窗样式 */
.batch-add-container {
  padding: 20px 0;
}

.batch-steps {
  margin-bottom: 10px;
}

.batch-content {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-content {
  text-align: center;
  max-width: 400px;
}

.step-icon {
  font-size: 64px;
  color: #409eff;
  margin-bottom: 0px;
}

.step-content h3 {
  font-size: 20px;
  color: #333;
  margin-bottom: 10px;
}

.step-content p {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
  line-height: 1.5;
}

.highlight {
  color: #409eff;
  font-weight: bold;
}

.batch-actions {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

/* 单项新增弹窗样式 */
.single-add-container {
  padding: 20px 0;
}

.add-user-header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 10px;
}

.header-icon {
  font-size: 40px;
  color: #409eff;
  margin-right: 15px;
}

.header-text h3 {
  margin: 0 0 5px 0;
  color: #333;
  font-size: 18px;
}

.header-text p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.user-form {
  max-height: 400px;
  overflow-y: auto;
}

.user-list {
  padding: 10px 0;
}

.user-item {
  margin-bottom: 25px;
  padding: 20px;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  background: #fafafa;
  transition: all 0.3s ease;
}

.user-item:hover {
  border-color: #409eff;
  background: #f8f9fa;
}

.user-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e6e6e6;
}

.user-number {
  font-weight: bold;
  color: #409eff;
  font-size: 16px;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

/* 模板操作按钮样式 */
.template-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;
}

  .template-actions .el-button {
    min-width: 120px;
  }

  /* 文件选择提示样式 */
  .file-selected-tip {
    color: #67c23a;
    background: #f0f9ff;
    border: 1px solid #b3d8ff;
    border-radius: 4px;
    padding: 8px 12px;
    margin: 10px 0;
    font-size: 14px;
  }

  .file-selected-tip .el-icon-document {
    margin-right: 5px;
  }

/* 上传组件样式优化 */
.upload-demo {
  margin: 20px 0;
}

::v-deep .el-upload-dragger {
  width: 100%;
  padding: 10px;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  background: #fafafa;
  transition: all 0.3s ease;
}

::v-deep .el-upload-dragger:hover {
  border-color: #409eff;
  background: #ecf5ff;
}

::v-deep .el-upload-dragger .el-icon-upload {
  font-size: 48px;
  color: #c0c4cc;
  margin-bottom: 16px;
}

::v-deep .el-upload__text {
  color: #606266;
  font-size: 14px;
}

::v-deep .el-upload__text em {
  color: #409eff;
  font-style: normal;
}

/* 自定义文件列表样式 */
.custom-file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  margin: 8px 0;
  background: #f8f9fa;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.custom-file-item:hover {
  background: #ecf5ff;
  border-color: #409eff;
}

.file-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.file-icon {
  font-size: 18px;
  color: #409eff;
  margin-right: 8px;
}

.file-name {
  font-size: 14px;
  color: #333;
  word-break: break-all;
}

.file-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.success-icon {
  font-size: 18px;
  color: #67c23a;
  animation: success-bounce 0.6s ease;
}

.remove-icon {
  font-size: 16px;
  color: #f56c6c;
  cursor: pointer;
  padding: 2px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.remove-icon:hover {
  background: #f56c6c;
  color: white;
}

@keyframes success-bounce {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .select-type-container {
    flex-direction: column;
  }

  .type-card {
    margin-bottom: 15px;
  }
}

/* ===== product_management 样式 ===== */
.a-btn {
    color: #409eff;
    font-size: 14px;
}
.row {
    display: flex;
    margin-bottom: 12px;
}
.reason-area {
    background-color: #fafafa;
    border-radius: 12px;
    padding-left: 12px;
    padding-right: 12px;
    white-space: pre-wrap;
}
.bb {
    border-bottom: 1px solid #eee;
    padding-bottom: 32px;
}
.price {
    color: red;
    font-size: 18px;
}
.remark-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
}
</style>
